import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Table, Column } from '../components/ui/Table';
import { Plus, Search, BadgeCheck, Ban } from 'lucide-react';
import { PenaltyProfileForm } from '../components/PenaltyProfileForm';
interface Penalty {
  id: string;
  penaltyId: string;
  type: string;
  status: 'active' | 'inactive';
}
export function PenaltiesSetup() {
  const [isCreating, setIsCreating] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  // Mock Data
  const penalties: Penalty[] = [{
    id: '1',
    penaltyId: 'PEN-001',
    type: 'Late Payment Penalty',
    status: 'active'
  }, {
    id: '2',
    penaltyId: 'PEN-002',
    type: 'Default Penalty',
    status: 'active'
  }, {
    id: '3',
    penaltyId: 'PEN-003',
    type: 'Bounce Charge',
    status: 'active'
  }, {
    id: '4',
    penaltyId: 'PEN-004',
    type: 'Prepayment Penalty',
    status: 'active'
  }, {
    id: '5',
    penaltyId: 'PEN-005',
    type: 'Overdue Interest',
    status: 'active'
  }, {
    id: '6',
    penaltyId: 'PEN-006',
    type: 'Legacy Late Fee',
    status: 'inactive'
  }];
  const filteredPenalties = penalties.filter(p => p.type.toLowerCase().includes(searchQuery.toLowerCase()) || p.penaltyId.toLowerCase().includes(searchQuery.toLowerCase()));
  const columns: Column<Penalty>[] = [{
    key: 'penaltyId',
    label: 'Penalty ID'
  }, {
    key: 'type',
    label: 'Penalty Type',
    render: item => <span className="font-medium text-gray-900" data-id="element-2152">{item.type}</span>
  }, {
    key: 'status',
    label: 'Status',
    render: item => <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${item.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-2153">
          {item.status === 'active' ? <BadgeCheck className="w-3 h-3 mr-1" data-id="element-2154" /> : <Ban className="w-3 h-3 mr-1" data-id="element-2155" />}
          {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
        </span>
  }];
  if (isCreating) {
    return <PenaltyProfileForm onBack={() => setIsCreating(false)} onSave={() => {
      // In a real app, this would save the data
      setIsCreating(false);
    }} data-id="element-2156" />;
  }
  return <div className="space-y-8 animate-in fade-in duration-500" data-id="element-2157">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-2158">
        <div data-id="element-2159">
          <h1 className="text-2xl font-bold text-gray-900 tracking-tight" data-id="element-2160">
            Penalties Setup
          </h1>
          <p className="text-gray-500 mt-1" data-id="element-2161">
            Configure penalty rules and charges for late payments and defaults.
          </p>
        </div>
        <Button size="lg" className="shadow-sm" onClick={() => setIsCreating(true)} data-id="element-2162">
          <Plus className="mr-2 h-5 w-5" data-id="element-2163" />
          Add New Penalty
        </Button>
      </div>

      {/* Search */}
      <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm" data-id="element-2164">
        <div className="relative" data-id="element-2165">
          <Search className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" data-id="element-2166" />
          <Input placeholder="Search penalties by ID or type..." className="pl-10 border-0 bg-gray-50 focus:bg-white transition-colors" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-2167" />
        </div>
      </div>

      {/* Table */}
      <Table columns={columns} data={filteredPenalties} onRowClick={penalty => console.log('Clicked penalty:', penalty)} keyExtractor={item => item.id} data-id="element-2168" />
    </div>;
}